import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from "./Footer"

const Home = () => {
  const [listId, setListId] = useState('');
  const navigate = useNavigate();

  const handleCreateNew = () => navigate('/create');
  const handleViewList = () => {
    if (listId.trim()) navigate(`/list/${listId.trim()}`);
  };
  const handleDemoList = () => navigate('/list/DEMO123');

  return (
    <div className="container">
      <div className="card">
        <h1 className="title">ELO-Board</h1>
        <button onClick={handleCreateNew} className="btn btn-primary">
          Create New List
        </button>

        <div className="input-group">
          <input
            type="text"
            placeholder="Enter List ID"
            value={listId}
            onChange={(e) => setListId(e.target.value)}
            className="input"
          />
          <button onClick={handleViewList} className="btn btn-secondary">
            View List
          </button>
        </div>

        <div className="demo-section">
          <h3>Demo Available!</h3>
          <p>Try entering "DEMO123" as the List ID to see a demo list.</p>
          <button onClick={handleDemoList} className="btn btn-outline">
            View Demo List
          </button>
          
        </div>

        <br></br><h2 className="description">Elo Board is a place where anything can be ranked — from the absurd to the serious. Create a list, then let people decide the order by voting in simple head-to-head matchups. Each vote updates the leaderboard in real time using an Elo rating system, so rankings shift dynamically as more people participate. Whether it’s favorite movies, weird hypotheticals, or niche trivia, Elo Board turns comparisons into a live, evolving contest.</h2>


      </div>
      <Footer />

    </div>
  );
};

export default Home;
